var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import fileUploadConfig from '../../../const/fileUploadConfig';
import { DragDropText, FileUploadContainer, FormField, MaxReachedText, SuggestionText, TinyText } from '../../../ui/organisms/DocumentPreviewList';
import { useDropzone } from 'react-dropzone';
import { Trans } from 'react-i18next';
import i18n, { t } from '../../../strings/i18n/i18n';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import theme from '../../../theme';
import Icon from '../../../ui/atoms/Icon';
import styled from 'styled-components';
import { colors, fontWeights } from 'syf-component-library/defaultTheme';
var BoldCtaText = styled(DragDropText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-weight: ", ";\n  color: ", ";\n"])), fontWeights.bold, colors.cyanBlue);
var UploadDocumentSection = function (_a) {
    var onDrop = _a.onDrop, onDropRejected = _a.onDropRejected, validator = _a.validator, maxFilesReached = _a.maxFilesReached;
    var maxFiles = fileUploadConfig.maxFiles, maxFileSize = fileUploadConfig.maxFileSize;
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var _b = useDropzone({
        onDrop: onDrop,
        onDropRejected: onDropRejected,
        validator: validator,
        disabled: maxFilesReached
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    var iconProps = maxFilesReached
        ? {
            name: 'falWarning',
            color: theme.colors.actionFlag
        }
        : {
            name: 'falCloudArrowUp',
            color: theme.colors.denimBlue
        };
    return (_jsxs(FileUploadContainer, __assign({}, getRootProps({ className: 'dropzone' }), { "data-cy": "drop-zone-container" }, { children: [_jsx(Icon, __assign({ size: "2xl" }, iconProps)), maxFilesReached ? (_jsxs(_Fragment, { children: [_jsx(MaxReachedText, { children: t('uploadDocuments.maxAttachmentsReached', {
                            maxAttachments: maxFiles
                        }) }), _jsx(SuggestionText, { children: t('uploadDocuments.pleaseSubmit') })] })) : (_jsxs(_Fragment, { children: [_jsx(DragDropText, { children: _jsx(Trans, { i18n: i18n, i18nKey: isLessThanTablet
                                ? t('uploadDocuments.tapToBrowseDocument')
                                : t('uploadDocuments.dragDropText'), components: [_jsx(BoldCtaText, { isInline: true })] }) }), _jsx(TinyText, { children: t('uploadDocuments.fileTypes') }), _jsx(TinyText, { children: t('uploadDocuments.fileSizeText', { maxFileSize: maxFileSize }) }), _jsx(TinyText, { children: t('uploadDocuments.maxAttachments', {
                            maxAttachments: maxFiles
                        }) })] })), _jsx(FormField, __assign({ name: "upload document", "aria-label": "upload documents" }, getInputProps()))] })));
};
export default UploadDocumentSection;
var templateObject_1;
//# sourceMappingURL=index.js.map